/**
 * Triggers a browser download for a Blob.
 *
 * Replaces the `file-saver` package, which was the last first-party CommonJS dependency in this
 * app and therefore forced an optimization bailout in the production build (CommonJS defeats
 * tree-shaking). Every call site only ever used `saveAs(blob, fileName)`, which the platform
 * has supported natively for years via `URL.createObjectURL` plus an anchor's `download`
 * attribute — the same thing file-saver does on any browser we support.
 *
 * The revoke is deferred rather than immediate: Firefox and Safari abort an in-flight download
 * if the object URL is revoked before they have finished reading it. 40s matches the delay
 * file-saver used, so behaviour is unchanged for large exports.
 */
export function saveAs(data: Blob, fileName: string): void {
    const url = URL.createObjectURL(data);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = fileName;
    anchor.rel = 'noopener';
    anchor.style.display = 'none';

    // Must be in the document for the synthetic click to dispatch in Firefox.
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    setTimeout(() => URL.revokeObjectURL(url), 40_000);
}
